import { useMemo, useState } from 'react'
import { errorHandler } from '../../../../services/util/error.service'
import StatusOperacaoHttp from '../../../../services/api/https/dashboard/status-operacao.http'
import * as DateUtil from '../../../../services/util/date.service'

const { dataInicial, dataFinal } = DateUtil.getPeriodoMesAtual()
const PICKING_META = 20
const RESUMO_SEPARACAO_META = 15
const CARREGAMENTO_META = 15
const VEICULO_EM_ROTA_META = 15
const APURACAO_ENTREGAS_META = 20
const ORDEM_COLETA_META = 15
const TOTAL_META = 100

const INITIAL_STATE = {
  errorMessage: null,
  isLoading: false,
  statusOperacao: [],
  pInicial: dataInicial,
  pFinal: dataFinal,
  pontuacaoMediaTotal: [
    { name: 'Realizado', value: 0, color: '#B1ECC1' },
    { name: 'Lacuna', value: 100, color: '#FFCACA' },
  ],
  pontuacaoMediaPicking: [
    { name: 'Realizado', value: 0, color: '#B1ECC1' },
    { name: 'Lacuna', value: 100, color: '#FFCACA' },
  ],
  pontuacaoMediaResumoSeparacao: [
    { name: 'Realizado', value: 0, color: '#B1ECC1' },
    { name: 'Lacuna', value: 100, color: '#FFCACA' },
  ],
  pontuacaoMediaCarregamento: [
    { name: 'Realizado', value: 0, color: '#B1ECC1' },
    { name: 'Lacuna', value: 100, color: '#FFCACA' },
  ],
  pontuacaoMediaVeiculoEmRota: [
    { name: 'Realizado', value: 0, color: '#B1ECC1' },
    { name: 'Lacuna', value: 100, color: '#FFCACA' },
  ],
  pontuacaoMediaApuracaoEntrega: [
    { name: 'Realizado', value: 0, color: '#B1ECC1' },
    { name: 'Lacuna', value: 100, color: '#FFCACA' },
  ],
  pontuacaoMediaOrdemColeta: [
    { name: 'Realizado', value: 0, color: '#B1ECC1' },
    { name: 'Lacuna', value: 100, color: '#FFCACA' },
  ],
  rankingTP: [],
}

export default function useStatusOperacaoLogistica() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    return {
      // Helper
      resetState() {
        setState(prev => ({ ...prev, isLoading: false, errorMessage: null, statusChange: false }))
      },

      setCondicoesIniciais(pInicial, pFinal, statusOperacao) {
        setState(prev => ({ ...prev, statusOperacao, pInicial, pFinal }))
      },

      // Event
      async onBtnPesquisarClick(pInicial, pFinal) {
        try {
          setState(prev => ({ ...prev, isLoading: true }))
          const statusOperacao = await StatusOperacaoHttp.getStatusOperacao(pInicial, pFinal)
          const {
            pontuacaoMediaTotal,
            pontuacaoMediaPicking,
            pontuacaoMediaResumoSeparacao,
            pontuacaoMediaCarregamento,
            pontuacaoMediaVeiculoEmRota,
            pontuacaoMediaApuracaoEntrega,
            pontuacaoMediaOrdemColeta,
          } = calcularPontuacaoMedia(statusOperacao)

          const rankingTP = top3TpsHandlers(statusOperacao)

          setState(prev => ({
            ...prev,
            isLoading: false,
            statusOperacao,
            pInicial,
            pFinal,
            pontuacaoMediaTotal,
            pontuacaoMediaPicking,
            pontuacaoMediaResumoSeparacao,
            pontuacaoMediaCarregamento,
            pontuacaoMediaVeiculoEmRota,
            pontuacaoMediaApuracaoEntrega,
            pontuacaoMediaOrdemColeta,
            rankingTP,
          }))
        } catch (e) {
          setState(prev => ({ ...prev, isLoading: false, errorMessage: errorHandler(e) }))
        }
      },
    }
  }, [])

  return { state, localDispatch }
}

function calcularPontuacaoMedia(statusOperacao) {
  if (statusOperacao.length === 0) {
    throw new Error('Nenhum informação das operações está disponível para o Período Selecionado')
  }
  let pontuacaoMediaTotal = 0
  let pontuacaoMediaPicking = 0
  let pontuacaoMediaResumoSeparacao = 0
  let pontuacaoMediaCarregamento = 0
  let pontuacaoMediaVeiculoEmRota = 0
  let pontuacaoMediaApuracaoEntrega = 0
  let pontuacaoMediaOrdemColeta = 0

  statusOperacao.forEach(o => {
    pontuacaoMediaTotal += o.total_real
    pontuacaoMediaPicking += o.picking_real
    pontuacaoMediaResumoSeparacao += o.resumo_separacao_real
    pontuacaoMediaCarregamento += o.carregamento_real
    pontuacaoMediaVeiculoEmRota += o.veiculo_em_rota_real
    pontuacaoMediaApuracaoEntrega += o.apuracao_entregas_real
    pontuacaoMediaOrdemColeta += o.ordem_coleta_real
  })

  const qteTps = statusOperacao.length
  const _pontuacaoMediaTotal = Math.round(pontuacaoMediaTotal / qteTps)
  const _pontuacaoMediaPicking = Math.round(pontuacaoMediaPicking / qteTps)
  const _pontuacaoMediaResumoSeparacao = Math.round(pontuacaoMediaResumoSeparacao / qteTps)
  const _pontuacaoMediaCarregamento = Math.round(pontuacaoMediaCarregamento / qteTps)
  const _pontuacaoMediaVeiculoEmRota = Math.round(pontuacaoMediaVeiculoEmRota / qteTps)
  const _pontuacaoMediaApuracaoEntrega = Math.round(pontuacaoMediaApuracaoEntrega / qteTps)
  const _pontuacaoMediaOrdemColeta = Math.round(pontuacaoMediaOrdemColeta / qteTps)

  return {
    pontuacaoMediaTotal: [
      { name: 'Realizado', value: _pontuacaoMediaTotal, color: '#B1ECC1' },
      { name: 'Lacuna', value: TOTAL_META - _pontuacaoMediaTotal, color: '#FFCACA' },
    ],
    pontuacaoMediaPicking: [
      { name: 'Realizado', value: _pontuacaoMediaPicking, color: '#B1ECC1' },
      { name: 'Lacuna', value: PICKING_META - _pontuacaoMediaPicking, color: '#FFCACA' },
    ],
    pontuacaoMediaResumoSeparacao: [
      { name: 'Realizado', value: _pontuacaoMediaResumoSeparacao, color: '#B1ECC1' },
      {
        name: 'Lacuna',
        value: RESUMO_SEPARACAO_META - _pontuacaoMediaResumoSeparacao,
        color: '#FFCACA',
      },
    ],
    pontuacaoMediaCarregamento: [
      { name: 'Realizado', value: _pontuacaoMediaCarregamento, color: '#B1ECC1' },
      { name: 'Lacuna', value: CARREGAMENTO_META - _pontuacaoMediaCarregamento, color: '#FFCACA' },
    ],
    pontuacaoMediaVeiculoEmRota: [
      { name: 'Realizado', value: _pontuacaoMediaVeiculoEmRota, color: '#B1ECC1' },
      {
        name: 'Lacuna',
        value: VEICULO_EM_ROTA_META - _pontuacaoMediaVeiculoEmRota,
        color: '#FFCACA',
      },
    ],
    pontuacaoMediaApuracaoEntrega: [
      { name: 'Realizado', value: _pontuacaoMediaApuracaoEntrega, color: '#B1ECC1' },
      {
        name: 'Lacuna',
        value: APURACAO_ENTREGAS_META - _pontuacaoMediaApuracaoEntrega,
        color: '#FFCACA',
      },
    ],
    pontuacaoMediaOrdemColeta: [
      { name: 'Realizado', value: _pontuacaoMediaOrdemColeta, color: '#B1ECC1' },
      { name: 'Lacuna', value: ORDEM_COLETA_META - _pontuacaoMediaOrdemColeta, color: '#FFCACA' },
    ],
  }
}

function top3TpsHandlers(statusOperacao) {
  const top3 = statusOperacao.slice(0, 3)
  return top3.map(s => ({
    tp: s.tp_name,
    pontuacao: s.total_real,
  }))
}
